<script setup lang="ts">
import { computed, ref } from 'vue';
import InputText from 'primevue/inputtext';

const props = defineProps({
  modelValue: String,
  index: {
    type: Number,
    required: true
  }
});
const inputValue = ref(props.modelValue);
const enableDelete = ref(false);
const visibleXmark = computed(() =>
  enableDelete.value ? 'visible' : 'hidden'
);
const trashIconColor = computed(() =>
  enableDelete.value ? '#ea3546' : '#b8c2cc'
);

const onDelete = () => {
  if (!enableDelete.value) {
    enableDelete.value = !enableDelete.value;
  } else {
    emit('onDelete', props.index);
  }
};

const onCancelDelete = () => {
  enableDelete.value = !enableDelete.value;
};
const emit = defineEmits(['update:modelValue', 'onDelete']);

const onChange = () => {
  emit('update:modelValue', inputValue.value);
};
</script>

<template>
  <div class="row-root">
    <FontAwesomeIcon :icon="[`fas`, `grip-vertical`]" class="icon grip" />
    <InputText v-model="inputValue"
      type="text"
      @input="onChange"
      class="matrix-input"/>
    <FontAwesomeIcon :icon="[`fal`, `trash`]"
      class="icon trash"
      @click="onDelete"/>
    <FontAwesomeIcon :icon="[`fas`, `xmark`]"
      class="icon xmark"
      @click="onCancelDelete"/>
  </div>
</template>

<style scoped lang="scss">
.row-root {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 250px;
}
.matrix-input {
  font-size: 14px;
}
.icon {
  cursor: pointer;
}
.grip {
  cursor: grab;
}
.xmark {
  visibility: v-bind(visibleXmark);
  color: #1ec2ad;
}
.trash {
  color: v-bind(trashIconColor);
}
</style>
